import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LoadingWrapper from 'components/LoadingWrapper';
import {
  fetchFields,
  fieldsLoading as fieldsLoadingSelector,
} from 'slices/field.slice';
import {
  fetchReservationModes,
  reservationModesLoading,
} from 'slices/reservationMode.slice';
import {
  fetchReservationTemplates,
  reservationTemplatesLoading,
} from 'slices/reservationTemplate.slice';
// REDUX
import { useAppDispatch } from 'slices/store';
import { Button, DefaultContentLayout } from '@timeedit/ui-components';
// COMPONENTS
import { ExamV3ReservationSettings } from '../../../components/AppService/ExamV3Settings/ReservationSettings';
// i18N
import intl from '../../../i18n/intl';
import {
  examV3SettingsLoadingSelector,
  fetchExamV3ReservationSettings,
  saveExamV3ReservationSettings,
} from '../../../slices/examV3Settings.slice';

const language: any = intl.messages;

const ReservationSettings = () => {
  const dispatch = useAppDispatch();
  const reservationModeLoading = useSelector(reservationModesLoading);
  const reservationTemplateLoading = useSelector(reservationTemplatesLoading);
  const reservationSettingsLoading = useSelector(examV3SettingsLoadingSelector);
  const fieldsLoading = useSelector(fieldsLoadingSelector);
  const loading =
    fieldsLoading &&
    reservationModeLoading &&
    reservationTemplateLoading &&
    reservationSettingsLoading;

  /**
   * EFFECTS
   */

  useEffect(() => {
    dispatch(fetchReservationModes());
    dispatch(fetchReservationTemplates());
    dispatch(fetchExamV3ReservationSettings());
    dispatch(fetchFields());
  }, []);

  /**
   * EVENT HANDLERS
   */
  const onSave = () => {
    dispatch(saveExamV3ReservationSettings());
  };

  return (
    <DefaultContentLayout
      title={language.exam_v3_reservation_settings_title}
      subtitle={language.exam_v3_reservation_settings_sub_title}
      actions={
        <Button type="primary" onClick={onSave}>
          {language.save_changes as string}
        </Button>
      }
    >
      <div
        className="inner-content--wrapper allow-scroll"
        style={{ padding: '10px', display: 'block' }}
      >
        <LoadingWrapper isLoading={loading}>
          <ExamV3ReservationSettings />
        </LoadingWrapper>
      </div>
    </DefaultContentLayout>
  );
};

export default ReservationSettings;
